<template>
  <div class="component_layout--sidebar" :class="sidebar ? 'open' : 'close'">
    <el-menu
      class="el-menu-vertical"
      @open="handleOpen"
      @close="handleClose"
      text-color="#222"
      active-text-color="#222"
      :router="true"
      :default-active="$route.path"
    >
      <div class="title">{{ $t("label.menu") }}</div>

      <div class="item-group" v-for="group in menu_items" :key="group.key">
        <div class="group" v-if="group.items">
          <div class="header">{{ $t(`menu.group.${group.key}`) }}</div>
          <div class="item-wrapper">
            <!-- <div class="item" v-for="item in group.items"></div> -->
            <router-link class="menu-link" :to="`/${item.path}`" v-for="item in group.items" :key="item.key">
              <el-menu-item :index="`/${item.path}`" :class="getActive(item)">
                <span>{{ $te(`menu.item.${item.key}`) ? $t(`menu.item.${item.key}`) : item.key }}</span>
              </el-menu-item>
            </router-link>
          </div>
        </div>
        <div class="single" v-else>
          <el-menu-item @click="go(group.path)" :index="`/${group.path}`">
            <!-- <i class="el-icon-menu"></i> -->
            <span>{{ $te(`menu.item.${group.key}`) ? $t(`menu.item.${group.key}`) : group.key }}</span>
          </el-menu-item>
        </div>
      </div>

    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    haveReadPermission(name) {
      return this.permissions.includes(`read_${name}`.toUpperCase());
    },
    getActive(item) {
      let regexp = /^\/([^\/]+)/.exec(this.$route.path);
      if(regexp != null && regexp.length >= 2) {
        return regexp[1] == item.path ? "is-active" : "";
      }else {
        return "";
      }
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions,
      sidebar: state => state.control.sidebar,
      ready: state => state.status.ready
    }),
    menu_items() {
      return Object.keys(this.$setting.sidebar).map(index=>{
        let group = this.$setting.sidebar[index];
        return {
          ...group,
          items: group.items ? group.items.filter(item=>this.haveReadPermission(item.key) || item["skip-permission"] || group["skip-permission"]) : undefined
        }
      }).filter(group=>{
        return group.items ? group.items.length > 0 : true;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.component_layout--sidebar{
  height: 100%;
  transition: width .5s, opacity 1.2s;
  .el-menu{
    height: calc(100vh - 37px);
    width: 140px;
    overflow-y: auto;
    .item-wrapper{
      .menu-link{
        text-decoration: none;
        // cursor: pointer!important;
        *{
        cursor: pointer!important;

        }
      }
    }
    .group{
      .header{
        background-color: var(--nav-group-bg);
        height: 25px;
        line-height: 25px;
        border-bottom: 1px dashed var(--layout-border-color);
        font-size: x-small;
        font-weight: bold;
        padding: 0 10px;
      }
    }
    .title{
      background: var(--general-header-bg);
      border: 1px solid  var(--layout-border-color);
      font-size: small;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-menu-item{
      font-size: small;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px dashed var(--layout-border-color);
      margin: 0 2px;
      &.is-active{
        background-color: var(--nav-active-bg);
        cursor: initial;
      }
      :last-child{
        padding-bottom: 30px;
      }
    }
  }
  &.open{
    visibility: visible;
    opacity: 1;
    width: 140px;
  }
  &.close{
    visibility: hidden;
    opacity: 0;
    width: 0;
  }
}
</style>